(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["variant-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hegichi-variant-selector')) {
    customElements.define(
      'hegichi-variant-selector',
      class HegichiVariantSelector extends HTMLElement {
        connectedCallback() {
          this.initializeAttempts = 0;
          this.initialize();
        }

        disconnectedCallback() {
          this.abortController?.abort();
          window.clearTimeout(this.initializeTimer);
        }

        initialize() {
          const nativeContainer = this.nextElementSibling;
          this.nativePicker = nativeContainer?.querySelector('variant-picker');

          if (!this.nativePicker) {
            this.initializeAttempts += 1;
            if (this.initializeAttempts < 20) {
              this.initializeTimer = window.setTimeout(() => this.initialize(), 50);
            }
            return;
          }

          this.abortController?.abort();
          this.abortController = new AbortController();
          const signal = this.abortController.signal;

          this.querySelectorAll('[data-input-id]').forEach((button) => {
            button.addEventListener('click', () => this.selectChoice(button), { signal });
          });

          this.nativePicker.addEventListener('input', () => this.syncFromNative(), { signal });
          this.nativePicker.addEventListener('change', () => this.syncFromNative(), { signal });

          this.syncFromNative();
          this.classList.add('is-ready');
        }

        selectChoice(button) {
          const inputId = button.dataset.inputId;
          const nativeTarget = this.nativePicker?.querySelector(`[data-input-id="${inputId}"]`);
          if (!nativeTarget) return;

          if (nativeTarget.tagName === 'OPTION') {
            const select = nativeTarget.closest('select');
            if (!select || select.value === nativeTarget.value) return;
            select.value = nativeTarget.value;
            select.dispatchEvent(new Event('input', { bubbles: true }));
            select.dispatchEvent(new Event('change', { bubbles: true }));
          } else if (nativeTarget.matches('input')) {
            if (nativeTarget.checked) return;
            nativeTarget.click();
          }

          this.updateChoiceState(button);
        }

        updateChoiceState(button) {
          const fieldset = button.closest('[data-option-position]');
          fieldset?.querySelectorAll('[data-input-id]').forEach((choice) => {
            const selected = choice === button;
            choice.classList.toggle('is-selected', selected);
            choice.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });

          const currentValue = fieldset?.querySelector('[data-current-value]');
          if (currentValue) currentValue.textContent = button.dataset.optionValue || '';
          this.updateSummary();
        }

        syncFromNative() {
          this.querySelectorAll('[data-option-position]').forEach((fieldset) => {
            const position = Number(fieldset.dataset.optionPosition) - 1;
            const select = this.nativePicker?.querySelectorAll('select')?.[position];
            const radio = this.nativePicker?.querySelectorAll('fieldset')?.[position]?.querySelector('input:checked');
            const value = select?.value || radio?.value;
            if (!value) return;

            fieldset.querySelectorAll('[data-input-id]').forEach((choice) => {
              const selected = choice.dataset.optionValue === value;
              choice.classList.toggle('is-selected', selected);
              choice.setAttribute('aria-pressed', selected ? 'true' : 'false');
            });

            const currentValue = fieldset.querySelector('[data-current-value]');
            if (currentValue) currentValue.textContent = value;
          });

          this.updateSummary();
        }

        updateSummary() {
          const values = [];
          const fieldsets = [...this.querySelectorAll('[data-option-position]')].sort((a, b) => {
            return Number(b.dataset.visualOption === 'true') - Number(a.dataset.visualOption === 'true');
          });

          fieldsets.forEach((fieldset) => {
            const selected = fieldset.querySelector('.is-selected[data-option-value]');
            if (selected?.dataset.optionValue) values.push(selected.dataset.optionValue);
          });

          const summary = this.querySelector('[data-selected-values]');
          if (summary && values.length) summary.textContent = values.join(' · ');

          const selectedVisual = this.querySelector('[data-visual-option="true"] .is-selected img');
          const summaryImage = this.querySelector('[data-selected-image]');
          if (selectedVisual && summaryImage) summaryImage.src = selectedVisual.src;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
